export default (...args: any[]) => {
    if (process.env.ENV_NODE) {
        const { map } = require('./node');
        return map(...args);
    }

    const { map } = require('./dom');
    return map(...args);
};
